import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { type ChatConversationWithUnreadInfoDto, PermissionDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { useHasAnyPermission } from '@/utils/usePermissions.util.ts';

type Response = ChatConversationWithUnreadInfoDto[];

type Return = {
  chatConversationsStatus: Response;
  isFetching: boolean;
  isPending: boolean;
};

export const useReadChatConversationsStatus = (params?: { refetchInterval?: number }): Return => {
  const { chatApi } = useApiClient();
  const { userId } = useUserContext();
  const canReadChats = useHasAnyPermission(PermissionDto.MenuChats);
  const { data, isFetching, isPending } = useQuery<Response>({
    enabled: canReadChats,
    queryFn: async () => {
      const { data } = await chatApi.readChatConversationsStatus(userId);
      return data;
    },
    queryKey: [QueryKeyEnum.CHATS.ALL_STATUS],
    refetchInterval: params?.refetchInterval,
  });

  return {
    chatConversationsStatus: data ?? [],
    isFetching,
    isPending,
  };
};
